import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { Line } from "react-chartjs-2";
// eslint-disable-next-line no-unused-vars
import { Chart } from "chart.js/auto";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import noImage from "../../images/placeholder.jpg";
import NumberFormatter from "../../Component/NumberFormatter";
import Dataloader from "../../Component/Dataloader";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import { fetchCashWallet } from "../../redux/slice/cashWallet";
import { fetchCreditWallet } from "../../redux/slice/creditWallet"; 
import Slider from "react-slick";

export default function ProductDetail() {
  const params = useParams();
  const dispatch = useDispatch();
  const logout = useLogout();
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const [relatedProduct, setRelatedProduct] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [brand, setBrand] = useState([]);
  const [variation, setVariation] = useState([]);
  const [unit, setUnit] = useState([]);
  const [qualityData, setQualityData] = useState([]);
  const [packaginCharge, setPackaginCharge] = useState([]);
  const [selectedQuality, setSelectedQuality] = useState(null);
  const [selectedImage, setSelectedImage] = useState(noImage);
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("weekly");
  const [graphData, setGraphData] = useState({ price: [] });
  const [qualityPriceArr, setQualityPriceArr] = useState([]);
  const [selectedPackagingCharge, setSelectedPackagingCharge] = useState(null);
  const [otherCharges, setOtherCharges] = useState([]);
  const [chartsImages, setChartsImages] = useState([]);

  const fetchProduct = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/product-detail/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );
      setProduct(response.data.products_data);
      setRelatedProduct(response.data.seller_product_list);
      setSelectedImage(response.data.products_data.thumbnail);
      setGallery(response.data.products_data.images.slice(0, 4));
      setBrand(response.data.products_data.brand);
      setChartsImages(response.data.products_data.charts || []);
      const filterVariation = response.data.products_data.variation.filter(
        (item) => item.is_selected === 1 && item.is_brand_selling === 1
      );
      setVariation(filterVariation);

      setOtherCharges(response.data.products_data?.other_charges || []);
      setUnit(
        response.data.products_data.variation[0].value[0].unit.short_name
      );
      setGraphData({
        price: Object.entries(response.data.products_data.price_history).map(
          ([day, price]) => ({
            day,
            price,
          })
        ),
      });
      const qualityName = response.data.products_data.quality;
      const qualityPrice = response.data.products_data.quality_price;
      setQualityPriceArr(qualityPrice);
      if (qualityName.length > 0 && qualityPrice.length > 0) {
        const qualityPriceArray = qualityName.map((qdata, index) => ({
          name: qdata,
          price: qualityPrice[index],
        }));
        setQualityData(qualityPriceArray);
        setSelectedQuality(qualityPriceArray[0]);
      }
      const packagingCharge = response.data.products_data.packaging_charge;
      if (packagingCharge.length > 0) {
        setPackaginCharge(packagingCharge);
        setSelectedPackagingCharge(packagingCharge[0]);
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setExist(false);
      }
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [params.id, logout]);
  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  const handleImageClick = (imgSrc) => {
    setSelectedImage(imgSrc);
  };

  const chartData = useMemo(() => {
    if (!graphData.price || graphData.price.length === 0) {
      return { labels: [], datasets: [] };
    }

    const sortedData = [...graphData.price].sort(
      (a, b) => new Date(a.day) - new Date(b.day)
    );

    const filteredData =
      filter === "weekly" ? sortedData.slice(-7) : sortedData;

    const labels = filteredData.map((item) => item.day);
    const prices = filteredData.map((item) => item.price);
    const colors =
      filter === "monthly" ? "rgb(255, 205, 86)" : "rgb(255, 99, 132)";

    return {
      labels,
      datasets: [
        {
          label: `Last Updated: ${product.last_updated || "N/A"}`,
          backgroundColor: colors,
          borderColor: colors,
          data: prices,
        },
      ],
    };
  }, [filter, graphData, product.last_updated]);

  const [selectedSizes, setSelectedSizes] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const handleChipClick = (item) => {
    if (!selectedSizes.find((size) => size.id === item.id)) {
      setSelectedSizes([...selectedSizes, item]);
    }
  };
  const handleQuantityChange = (id, quantity) => {
    setQuantities({
      ...quantities,
      [id]: {
        quantity: String(parseInt(quantity) || 0),
      },
    });
  };
  const handleRemoveSize = (id) => {
    setSelectedSizes(selectedSizes.filter((size) => size.id !== id));
    const newQuantities = { ...quantities };
    delete newQuantities[id];
    setQuantities(newQuantities);
  };

  const exCalc = useCallback(
    (guage) => {
      const baseTotal =
        +product.base_price +
        +product.total_charges +    // Keep this, and it's now part of the dependency array
        +guage +
        // +product.loading_charge +
        // +product.insurance_charge +
        +(selectedQuality?.price || 0) +
        +(selectedPackagingCharge?.charge || 0);


      const gstAmount = (+product.gst / 100) * baseTotal;
      const exPrice = baseTotal + gstAmount;
      return Math.round(exPrice);
    },
    [
      product.base_price,
      product.gst,
      // product.insurance_charge,
      // product.loading_charge,
      selectedQuality?.price,
      selectedPackagingCharge?.charge,
      product.total_charges,
    ]
  );

  useEffect(() => {
    const total = selectedSizes.reduce((sum, size) => {
      const qtObj = quantities[size.id];
      return sum + (qtObj ? exCalc(size.price) * qtObj.quantity : 0);
    }, 0);
    setTotalPrice(total);
  }, [quantities, selectedSizes, exCalc]);

  const handleQualitySelect = (qdata) => {
    setSelectedQuality(qdata);
  };

  const handlePackagingSelect = (packagin) => {
    setSelectedPackagingCharge(packagin);
  };

  const handleRequestQuote = () => {
    if (selectedSizes.length === 0) {
      toast.error("Please select at least one variant", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    const allQuantitiesValid = selectedSizes.every(
      (size) => quantities[size.id] && quantities[size.id].quantity > 0
    );
    if (!allQuantitiesValid) {
      toast.error("Please enter a quantity for each selected variant", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    const finalVariations = selectedSizes.map((size) => ({
      ...size,
      quantity: quantities[size.id].quantity,
      stock: null,
      user_selected: "true",
    }));

    navigate("/create-rfq", {
      state: { finalVariations, product, selectedQuality, selectedPackagingCharge },
    });
  };

  const imageOnError = (event) => {
    event.currentTarget.src = noImage;
  };
  const bookmark = async (event, cp_id, scp_id, type) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${config.apiUrl}/bookmark`,
        { commodity_product_id: cp_id, seller_commodity_product_id: scp_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );
      switch (type) {
        case "detail":
          setProduct((prevProduct) => ({
            ...prevProduct,
            is_bookmarked: !product.is_bookmarked,
          }));
          break;
        case "related":
          setRelatedProduct((prevRelatedProduct) =>
            prevRelatedProduct.map((relp) =>
              relp.id === scp_id
                ? { ...relp, is_bookmarked: !relp.is_bookmarked }
                : relp
            )
          );
          break;
        default:
          break;
      }

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };


  const {cashAmount, isError } = useSelector(
    (state) => state.cashWallet
  );

  const {creditAmount, isError1 } = useSelector(
    (state) => state.creditWallet
  );

  useEffect(() => {
    const fetchData = async () => {
      if (!isError && !isError1) {
        setLoading(true);
        try {
          await dispatch(fetchCashWallet(logout));
          await dispatch(fetchCreditWallet(logout));
        } catch (error) {
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError, isError1, logout]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="product_detail">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                {exist ? (
                  <div className="row g-4">
                    <div className="col-lg-5 px-2">
                      <div className="product_gallery_main">
                        <div className="product-image-gallery">
                          {gallery.map((img, index) => {
                            return (
                              <div
                                className="product-gallery-item"
                                onMouseEnter={() => handleImageClick(img)}
                                key={index}
                              >
                                <img
                                  src={img}
                                  onError={imageOnError}
                                  alt="product-preview"
                                />
                              </div>
                            );
                          })}
                        </div>
                        <div className="product-main-image">
                          {selectedImage && (
                            <img
                              src={selectedImage}
                              onError={imageOnError}
                              alt="preview"
                            />
                          )}
                          <div className="absolute_menu">
                            <div className="social-icons social-icons-sm">
                              <div
                                className={`social-icon product-wishlist ${product.is_bookmarked && "active"
                                  }`}
                                onClick={(e) =>
                                  bookmark(
                                    e,
                                    product.commodity_product_id,
                                    product.seller_commodity_product_id,
                                    "detail"
                                  )
                                }
                                title="Watchlist"
                              >
                                <i className="bi bi-bookmark"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 px-2 second-div">
                      <div className="product-details">
                        <h1 className="product-title mt-0">{product.name}</h1>
                        <div
                          className="product-content"
                          dangerouslySetInnerHTML={{
                            __html: product.description,
                          }}
                        />
                        <div
                          className="badge bg-primary"
                          style={{ fontSize: 13, fontWeight: 400 }}
                        >
                          MOQ{" "}
                          <span style={{ fontSize: 10 }}>
                            (Minimun Order Quantity)
                          </span>{" "}
                          : {product && product.min_order_qty}{" "}
                          {product && product.unit && product.unit.name}
                        </div>
                      </div>
                      <div className="product-details">
                        <h6>Product Details</h6>
                        <div className="select-product-attr">
                          <table>
                            <tbody>
                              <tr>
                                <td className="hd">Base Price:</td>
                                <td>
                                  <span>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={product.base_price}
                                    />
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td className="hd">Brand:</td>
                                <td>
                                  <span>{brand.name}</span>
                                </td>
                              </tr>
                              <tr>
                                <td className="hd">Quality:</td>
                                <td>
                                  <span>
                                    {qualityData.length > 0
                                      ? qualityData[0].name
                                      : "--"}
                                    {qualityData.length > 1 &&
                                      "  +" +
                                      (qualityData.length - 1) +
                                      " more"}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td className="hd">Default (Size):</td>
                                <td>
                                  {product.default_variation && product.default_variation.length > 0 ? (
                                    product.default_variation.map((variation, index) => (
                                      <span key={index}>
                                        {variation.name}: {variation.value} {variation.unit?.short_name}
                                        {index !== product.default_variation.length - 1 && ', '}
                                      </span>
                                    ))
                                  ) : (
                                    <span>--</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className="hd">Location:</td>
                                <td>
                                  <span>Ex-{product.address}</span>
                                </td>
                              </tr>
                              <tr>
                                <td className="hd">Ex Price:</td>
                                <td>
                                  <span>
                                    Rs{" "}
                                    <NumberFormatter
                                      number={product.ex_price}
                                    />
                                  </span>
                                  <span title="View Calculation" data-bs-toggle="modal" data-bs-target="#calulationModal">
                                    <i className="bi bi-info-circle text-danger"></i>{" "}
                                  </span>
                                  <small className="ms-2 text-success">
                                    (GST & other charges included)
                                  </small>
                                </td>
                              </tr>
                              <tr>
                                <td className="hd">Last Updated:</td>
                                <td>
                                  <span>{product.last_updated}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <small className="text-primary mt-1">
                            *Disclaimer: The prices displayed are based on the
                            last updated rates and are subject to change due to
                            fluctuations in demand, supply, and order quantity.
                            For the most accurate and up-to-date pricing, please
                            submit your requirement.
                          </small>
                        </div>
                      </div>
                      {qualityData.length > 0 && (
                        <div className="product-details">
                          <h6>Select Quality</h6>
                          <div className="chip-group">
                            {qualityData.map((q, index) => (
                              <div
                                className={`chip ${selectedQuality &&
                                  selectedQuality.name === q.name
                                  ? "active"
                                  : ""
                                  }`}
                                key={index}
                                onClick={() => handleQualitySelect(q)}
                              >
                                <span>{q.name}</span>
                                <small>
                                  Rs{" "}
                                  {qualityPriceArr[index] ? (
                                    <NumberFormatter number={qualityPriceArr[index]} />
                                  ) : (
                                    "0"
                                  )}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {packaginCharge.length > 0 && (
                        <div className="product-details">
                          <h6>Select Packaging</h6>
                          <div className="chip-group">
                            {packaginCharge.map((packagin, index) => (
                              <div
                                className={`chip ${selectedPackagingCharge &&
                                  selectedPackagingCharge.id === packagin.id
                                  ? "active"
                                  : ""
                                  }`}
                                key={index}
                                onClick={() => handlePackagingSelect(packagin)}
                              >
                                <span>{packagin.name}</span>
                                <small>
                                  Rs{" "}
                                  {packagin.charge ? (
                                    <NumberFormatter number={packagin.charge} />
                                  ) : (
                                    "0"
                                  )}
                                </small>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div className="product-details">
                        <div className="d-flex justify-content-between border-top">
                          <h6 className="border-0">Select Variations</h6>
                          <div className="float-end pt-1">
                            <button
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#viewVariation"
                              title="View Variations"
                              className="btn border-0 p-0 text-primary text-decoration-underline"
                            >
                              View Variations
                            </button>
                            {"  | "}
                            <button
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#viewChart"
                              title="View Chart"
                              className="btn border-0 p-0 text-primary text-decoration-underline"
                            >
                              View Chart
                            </button>
                          </div>
                        </div>
                        <div className="chip-group">
                          {variation.map((value) => {
                            return (
                              <div
                                className={`chip ${selectedSizes.find(
                                  (size) => size.id === value.id
                                )
                                  ? "active"
                                  : ""
                                  }`}
                                key={value.id}
                                onClick={() => handleChipClick(value)}
                              >
                                <span>
                                  {value.value[0] && value.value[0].value}{" "}
                                  {unit}
                                </span>
                                <small>
                                  {value.value[1] && value.value[1].value > 0
                                    ? value.value[1].value
                                    : "-"}{" "}
                                  {value.value[1] && value.value[1].value > 0
                                    ? value.value[1].unit.short_name
                                    : "-"}
                                </small>
                              </div>
                            );
                          })}
                        </div>

                        {selectedSizes.length > 0 && (
                          <>
                            <div className="table-responsive">
                              <table className="table price-table">
                                <thead>
                                  <tr>
                                    <th>Sizes</th>
                                    <th>Ex Price</th>
                                    <th>Quantity in MT</th>
                                    <th>Total Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedSizes.map((item) => (
                                    <tr key={item.id}>
                                      <td>
                                        {item.value[0] && item.value[0].value}{" "}
                                        {unit} (
                                        <small>
                                          {item.value[1] &&
                                            item.value[1].value > 0
                                            ? item.value[1].value
                                            : "-"}{" "}
                                          {item.value[1] &&
                                            item.value[1].value > 0
                                            ? item.value[1].unit.short_name
                                            : "-"}
                                        </small>
                                        )
                                      </td>
                                      <td>
                                        Rs{" "}
                                        <NumberFormatter
                                          number={exCalc(item.price)}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          placeholder="Enter quantity"
                                          className="form-control"
                                          min={1}
                                          onChange={(e) =>
                                            handleQuantityChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          onWheel={(e) => e.target.blur()}
                                        />
                                      </td>
                                      <td>
                                        Rs{" "}
                                        {quantities[item.id] ? (
                                          <NumberFormatter
                                            number={
                                              exCalc(item.price) *
                                              quantities[item.id].quantity
                                            }
                                          />
                                        ) : (
                                          0
                                        )}
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn-danger close-btn"
                                          onClick={() =>
                                            handleRemoveSize(item.id)
                                          }
                                        >
                                          <i className="bi bi-x-lg"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            <div className="total_price">
                              <p>
                                Total Ex Factory Price:{" "}
                                <span>
                                  Rs <NumberFormatter number={totalPrice} />
                                </span>
                              </p>
                              <p className="price_note">
                                *Note: Ex-price = Basic Price + Guage Difference
                                + Loading + Insurance + Quality Charge (If
                                Applicable) + GST
                              </p>
                              <p className="price_note">
                                *TCS may apply (If Applicable)
                              </p>
                            </div>
                          </>
                        )}
                        <div className="product-details-action">
                          {/* <p>Cash Wallet: {cashAmount}</p>
                          <p>Credit Wallet: {creditAmount}</p> */}
                          <button
                            className="btn-product btn-buy"
                            onClick={handleRequestQuote}
                          >
                            Request For Quotes
                          </button>
                        </div>
                      </div>
                      {relatedProduct.length > 0 && (
                        <div className="product-details">
                          <h6>Related Product</h6>
                          <div className="row g-3">
                            {relatedProduct.map((rdata, index) => (
                              <div
                                className="col-lg-6 col-md-6 col-6 px-2"
                                key={index}
                              >
                                <div className="product-area">
                                  <Link to={`/product-detail/${rdata.id}`}>
                                    <div className="home-product">
                                      <div className="product-image">
                                        <img
                                          src={rdata.thumbnail}
                                          onError={imageOnError}
                                          alt="product"
                                        />
                                      </div>
                                      <div className="row product-detail">
                                        <div className="col-12">
                                          <h6
                                            className="one-line-clamp"
                                            style={{
                                              paddingTop: 0,
                                              borderTop: 0,
                                            }}
                                          >
                                            {rdata.name}
                                          </h6>
                                        </div>
                                        <div className="col-12">
                                          <div className="product-tag">
                                            <div>
                                              <span className="f-500">
                                                Brand:
                                              </span>
                                              <span>{rdata.brand}</span>
                                            </div>
                                            <div>
                                              <span className="f-500">
                                                Quality:
                                              </span>
                                              <span>
                                                {rdata.quality &&
                                                  rdata.quality.length > 0
                                                  ? rdata.quality[0]
                                                  : "--"}
                                              </span>
                                            </div>
                                            <div>
                                              <span className="f-500">
                                                Size:
                                              </span>
                                              <span>
                                                {rdata.default_variation &&
                                                  rdata.default_variation[0]
                                                  ? rdata.default_variation[0]
                                                    .value +
                                                  " " +
                                                  rdata.default_variation[0]
                                                    .unit.short_name
                                                  : "--"}
                                              </span>
                                            </div>
                                            <div>
                                              <span className="f-500">
                                                Location:
                                              </span>
                                              <span>Ex-{rdata.city}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row rate-area">
                                        <div className="col-12">
                                          <h6 className="p-0 border-0">
                                            Rs{" "}
                                            <NumberFormatter
                                              number={rdata.ex_price != 0 ? rdata.ex_price : rdata.base_price}
                                            />
                                            /{rdata.unit_name}
                                          </h6>
                                          <span>
                                            GST & other charges included
                                          </span>
                                        </div>
                                        <div className="col-12">
                                          <button className="price-statusup btn">
                                            Get Best Price
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                  <div className="details-action-wishButton">
                                    <div
                                      className={`btn-wishlist ${rdata.is_bookmarked && "active"
                                        }`}
                                      onClick={(e) =>
                                        bookmark(
                                          e,
                                          rdata.commodity_product_id,
                                          rdata.id,
                                          "related"
                                        )
                                      }
                                      title="Watchlist"
                                    >
                                      <i className="bi bi-bookmark"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div className="product-details">
                        <h6>Price Updates</h6>
                        <select
                          value={filter}
                          onChange={(e) => setFilter(e.target.value)}
                          className="graph-filter"
                        >
                          <option value="weekly">Last 7 days</option>
                          <option value="monthly">Last 30 days</option>
                        </select>
                        <Line data={chartData} />
                      </div>
                      <div className="product-details">
                        <h6>Delivery Info</h6>
                        <div className="product-content">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: product.product_delivery_info,
                            }}
                          />
                        </div>
                      </div>
                      <div className="product-details mb-0">
                        <h6>Terms & Condition</h6>
                        <div className="product-content">
                          <div className="product-tc">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: product.product_terms_condition,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-lg-12">
                      <NoData />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="viewVariation"
        tabIndex="-1"
        aria-labelledby="viewVariationLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-0">
            <div className="body" data-bs-dismiss="modal">
              <div className="row">
                <div className="col-lg-12">
                  <table className="table chart-table text-center table-responsive">
                    <thead>
                      <tr>
                        {variation[0] && variation[0].value[0] && <th>Size</th>}
                        {variation[0] && variation[0].value[1] && (
                          <th>Weight</th>
                        )}
                        {variation[0] && variation[0].value[2] && (
                          <th> Thickness</th>
                        )}
                        {variation[0] && variation[0].value[3] && (
                          <th>Gauge</th>
                        )}
                        <th>Guage Diff.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {variation.map((chart, index) => (
                        <tr key={index}>
                          {chart.value[0] && (
                            <td className="p-1">
                              {chart.value[0] && chart.value[0].value} {unit}
                            </td>
                          )}
                          {chart.value[1] && (
                            <td className="p-1">
                              {chart.value[1] && chart.value[1].value}{" "}
                              {chart.value[1] && chart.value[1].unit.short_name}
                            </td>
                          )}
                          {chart.value[2] && (
                            <td className="p-1">
                              {chart.value[2] && chart.value[2].value}{" "}
                              {chart.value[2] && chart.value[2].unit.short_name}
                            </td>
                          )}
                          {chart.value[3] && (
                            <td className="p-1">
                              {chart.value[3] && chart.value[3].value}{" "}
                              {chart.value[3] && chart.value[3].unit.short_name}
                            </td>
                          )}
                          <td className="p-1">Rs {chart.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <button
                  type="button"
                  className="abslt_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="viewChart"
        tabIndex="-1"
        aria-labelledby="viewChartLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-0">
            <div className="body">
              <div className="row">
                <div className="col-lg-12">
                  {chartsImages && chartsImages.length > 0 ? (
                    <Slider
                      dots={true}
                      infinite={true}
                      speed={500}
                      slidesToShow={1}
                      slidesToScroll={1}
                      arrows={true}
                    >
                      {chartsImages.map((image, index) => (
                        <div key={index} className="chart-image-slide">
                          <img
                            src={image}
                            alt={`Chart ${index + 1}`}
                            onError={imageOnError}
                            className="img-thumbnail"
                            style={{ width: "100%", maxHeight: 400, objectFit: "contain" }}
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <p className="text-center">No chart available</p>
                  )}
                </div>
                <button
                  type="button"
                  className="abslt_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="calulationModal"
        tabIndex="-1"
        aria-labelledby="calulationModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-0">
            <div className="body mt-1 p-4" data-bs-dismiss="modal">
              <div className="row">
                <div className="col-lg-12">
                  <h6 className="text-center">Calculation</h6>

                  <p><b>Base Price: </b>Rs{" "}
                    <NumberFormatter number={product.base_price} />
                  </p>

                  <p><b>Guage Difference: </b>
                    + Rs{" "}
                    <NumberFormatter number={product.default_variation_price} />
                  </p>

                  {product.loading_charge > 0 && (
                    <p><b>Loading Charge: </b>
                      + Rs{" "}
                      <NumberFormatter
                        number={product.loading_charge}
                      />
                    </p>
                  )}

                  {product.insurance_charge > 0 && (
                    <p><b>Insurance Charge: </b>
                      + Rs{" "}
                      <NumberFormatter
                        number={product.insurance_charge}
                      />
                    </p>
                  )}

                  {product.quality_charge > 0 && (
                    <p><b>Quality Charge: </b>
                      + Rs{" "}
                      <NumberFormatter
                        number={product.quality_charge}
                      />
                    </p>
                  )}
                  {otherCharges && otherCharges.length > 0 && (
                    otherCharges.map((other_charge, charges) => (

                      other_charge.price > 0 ? (
                        <p key={charges}>
                          <b>{other_charge.name}: </b>
                          {other_charge.operator} Rs{" "}
                          <NumberFormatter
                            number={other_charge.price}
                          />
                        </p>
                      ) : null
                    ))
                  )}
                  <br />
                  <p><b>Total:</b> Rs{" "}
                    <NumberFormatter
                      number={product.total_amount}
                    /> 
                  </p>
                  <p><b>GST:</b> + {product.gst} %</p>
                  <p className="text-success"><b>Ex Price:</b> Rs{" "}
                    <NumberFormatter number={product.ex_price} />
                  </p>
                </div>
                <button
                  type="button"
                  className="abslt_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
